// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__CyLnW","item":"Footer_item__U35WC","label":"Footer_label__ePTsq","text":"Footer_text__vFCRM"};